<template>
  <div class="archived-section" @click="handleAllButtonClick" style="cursor: pointer">
    <!--          <div>-->
    <div class="group">
      <svg
          class="path"
          width="98"
          height="106"
          viewBox="0 0 98 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M48.9211 20.5801C53.8972 17.1376 58.1947 12.7993 62.8768 8.96998C66.805 5.75333 71.1626 3.10025 75.8237 1.08738C78.6872 -0.134027 85.4457 -0.199621 87.7279 2.207C88.1079 2.60735 88.2753 3.15699 88.4404 3.684C90.2205 9.42235 92.2584 14.7377 93.7173 20.5847C95.1898 26.4881 96.3592 32.4775 96.8998 38.5439C98.4831 56.347 94.6379 74.3447 87.8523 90.8789C84.0886 100.042 79.6191 105.909 69.0223 105.147C50.9274 103.844 32.6063 102.471 15.5066 96.4114C12.444 95.3257 8.96073 93.4981 8.65085 90.2614C8.57169 89.4268 8.62371 88.384 7.88408 87.986C7.44754 87.7598 6.90922 87.8706 6.42292 87.7598C5.02282 87.4522 4.72426 85.6133 4.72878 84.1793C3.59785 83.5731 2.43751 82.9081 1.68657 81.8631C0.600876 80.3499 -0.753982 77.604 1.05099 76.1089C1.75669 75.5231 2.69536 75.3354 3.55713 75.021C5.819 74.1931 7.59909 72.4424 9.18918 70.6375C14.1336 65.0134 17.8835 58.4432 20.2112 51.3257"
            fill="#F3D8D9"
        />
      </svg>

      <svg
          class="path2"
          width="100"
          height="108"
          viewBox="0 0 100 108"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M50.229 22.1095C56.9173 17.4998 62.4724 11.447 69.3055 7.03639C70.9926 5.94471 72.7392 4.94794 74.5372 4.05073C75.9396 3.35182 77.3465 2.65064 78.8936 2.34981C81.4495 1.8522 84.6817 1.83184 87.0612 3.02837C88.7101 3.85621 88.8955 5.72677 89.4226 7.34627C90.0717 9.34124 90.748 11.3272 91.404 13.3199C92.7136 17.3007 93.8535 21.3155 94.7741 25.405C96.6537 33.7739 97.658 42.2491 97.3708 50.8238C97.0903 59.1927 95.7128 67.4983 93.5256 75.5754C92.4263 79.6287 91.134 83.6246 89.6487 87.5633C88.4567 90.7299 87.2218 93.9282 85.5389 96.8777C84.2497 99.1395 82.6483 101.318 80.4995 102.842C78.3507 104.367 75.7496 105.161 73.0874 105.33C69.2264 105.556 65.2387 104.955 61.3913 104.652C57.2453 104.319 53.1015 103.944 48.9691 103.471C40.5459 102.51 32.1499 101.121 23.9755 98.841C20.456 97.8593 16.5362 96.9478 13.4058 94.9958C12.103 94.1838 10.8725 93.0415 10.6034 91.4605C10.3885 90.2074 10.5423 88.7169 9.13314 88.1265C8.3528 87.8008 7.47067 88.1604 7.00473 87.3055C6.66997 86.6902 6.66092 85.8895 6.65414 85.2087C6.65494 84.882 6.48288 84.5791 6.20176 84.4125C4.64786 83.5734 3.48753 82.6958 2.68456 81.0966C2.35433 80.4407 2.006 79.6174 2.11457 78.8642C2.23898 77.93 3.01932 77.5659 3.82907 77.2809C5.3694 76.7245 6.71747 76.1499 8.01126 75.1163C9.35707 74.0487 10.4993 72.7662 11.6167 71.4566C16.3223 65.9266 19.8807 59.5157 22.0846 52.5971C22.4306 51.4888 20.7275 51.041 20.3565 52.1199C17.7576 59.584 13.7496 67.0211 8.04518 72.5965C6.7171 73.9081 5.10501 74.8964 3.33372 75.4849C1.82279 76.0165 0.506388 76.8896 0.291511 78.595C-0.124672 81.8747 2.66421 84.6071 5.26761 86.0094L4.81524 85.2132C4.83107 86.5704 5.01655 88.1695 6.10677 89.1217C6.70616 89.6465 7.28294 89.5741 7.99316 89.7664C8.9816 90.0355 8.67172 91.2818 8.87303 92.1255C9.58325 95.2582 12.8041 96.984 15.5501 98.0493C23.7267 101.216 32.5547 102.964 41.2019 104.24C49.9937 105.536 58.8444 106.242 67.7154 106.88C71.0449 107.119 74.3653 107.332 77.584 106.251C80.1182 105.394 82.381 103.882 84.1434 101.87C86.0705 99.6937 87.4887 97.1197 88.6829 94.4891C90.3382 90.7681 91.7976 86.9629 93.0551 83.0893C95.8304 74.7204 97.7847 66.0846 98.6442 57.3041C99.505 48.4384 99.1427 39.4964 97.5675 30.7294C96.7747 26.1924 95.7235 21.7043 94.419 17.2872C93.1546 13.0552 91.655 8.90017 90.3296 4.68858C89.8772 3.28396 89.2529 2.28874 87.9139 1.61244C86.6631 0.981382 85.272 0.707696 83.8878 0.551628C80.971 0.206982 78.0156 0.665281 75.3402 1.87708C71.5406 3.62381 67.9533 5.79955 64.6484 8.36185C61.2556 10.9766 58.1772 13.9667 54.963 16.785C53.2652 18.3113 51.4871 19.7458 49.6364 21.0826C48.9985 21.535 49.6002 22.5912 50.2538 22.1411L50.229 22.1095Z"
            fill="#232323"
        />
      </svg>

      <svg
          class="path3"
          width="99"
          height="102"
          viewBox="0 0 99 102"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M87.731 22.2386C87.0125 33.3059 85.2156 44.2767 82.3659 54.995L75.2976 81.8275C74.9832 83.0217 74.5738 84.3404 73.4881 84.9443C72.8638 85.2949 72.131 85.3356 71.4049 85.3673C58.4761 85.9124 45.3934 85.4351 32.7112 82.6711C26.4529 81.3424 20.3521 79.3576 14.5099 76.7496C12.9493 76.0439 0.386853 69.3442 0.185547 69.5727C16.7899 50.7675 27.5541 27.8435 32.9193 3.45383C33.1093 2.59206 33.3264 1.67827 33.9642 1.06983C35.0658 0.0135367 36.8436 0.334722 38.3228 0.716977C56.9328 5.52665 75.9141 8.76347 95.0663 10.3932C102.266 41.3107 96.9232 73.4993 78.8736 99.8093C78.5795 100.239 78.2651 100.68 77.8082 100.927C77.3513 101.173 76.7565 101.178 76.2114 101.178C56.3621 101.042 36.7479 96.8711 18.5609 88.9184C18.0837 88.7103 17.5544 88.4411 17.4051 87.939C17.2355 87.369 17.6449 86.8081 18.0294 86.3444L23.4126 79.9456"
            fill="white"
        />
      </svg>

      <svg
          class="group2"
          width="109"
          height="117"
          viewBox="0 0 109 117"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M88.1691 23.2387C87.4349 34.1049 85.6664 44.8764 82.8876 55.407C81.4807 60.7404 80.0467 66.0671 78.6262 71.3961C77.916 74.0651 77.2073 76.7333 76.5001 79.4008C76.1744 80.6313 75.8736 81.8731 75.5162 83.0967C75.1385 84.3996 74.6114 85.4513 73.1322 85.6368C70.4745 85.9715 67.6652 85.8471 64.9895 85.863C62.3137 85.8788 59.5949 85.8494 56.8988 85.7499C51.3549 85.5637 45.8274 85.0425 40.3464 84.1892C31.489 82.7778 22.4279 80.4797 14.4074 76.3699C11.6773 74.9721 8.96533 73.5403 6.23752 72.1425C5.0704 71.5454 3.90553 70.9437 2.72032 70.3828C2.1639 70.1204 1.42879 69.6205 0.804518 69.9146L1.70926 71.0862C12.9711 58.3157 21.7109 43.5073 27.8112 27.6267C29.3583 23.6006 30.7373 19.5165 31.9481 15.3742C32.5362 13.3612 33.0866 11.3368 33.5993 9.30112C33.8617 8.25161 34.1173 7.19984 34.3593 6.1345C34.5855 5.16416 34.6827 3.98347 35.1781 3.10587C36.309 1.1109 39.8194 2.66933 41.4457 3.07872C43.7905 3.67284 46.1428 4.24132 48.5027 4.78417C53.3597 5.90455 58.2401 6.91862 63.1438 7.82638C74.0369 9.84245 85.01 11.33 96.063 12.289L95.1763 11.6105C99.7702 31.6122 99.2047 52.6611 92.885 72.2285C89.7081 82.0901 85.1308 91.4443 79.2935 100.004C78.9655 100.484 78.6896 100.984 78.1128 101.164C77.5767 101.332 76.9412 101.237 76.3847 101.23C74.8542 101.212 73.3229 101.169 71.7909 101.101C69.0073 100.979 66.229 100.777 63.4559 100.495C57.8561 99.9232 52.2945 99.0245 46.7995 97.8034C40.6772 96.4465 34.6483 94.6982 28.7499 92.5694C25.8253 91.5131 22.869 90.4297 20.0462 89.1065C18.965 88.5976 19.6594 88.057 20.2724 87.3264L21.677 85.63C22.8079 84.2729 23.9117 82.9158 25.0449 81.5587C25.7574 80.7127 24.5405 79.4823 23.8235 80.335C22.7853 81.57 21.7268 82.7868 20.6773 84.0128C19.7363 85.112 18.5308 86.2045 17.8047 87.4666C16.2644 90.1447 20.0666 91.1603 21.8308 91.8976C27.3589 94.1993 33.0244 96.1558 38.7948 97.7559C50.3714 100.967 62.2967 102.752 74.3061 103.074C75.5886 103.107 76.9434 103.248 78.2168 103.074C79.3727 102.906 80.0603 102.207 80.7049 101.287C82.3425 98.9614 83.8376 96.5231 85.258 94.0622C93.4022 79.9207 98.325 64.1561 99.6752 47.8931C100.703 35.5778 99.7868 23.1775 96.9609 11.1468C96.8445 10.7508 96.4847 10.4762 96.072 10.4682C85.9238 9.61325 75.8253 8.31419 65.7766 6.57104C60.8638 5.71606 55.9722 4.7525 51.1016 3.68038C48.6648 3.14356 46.2356 2.58187 43.8139 1.99529C41.6742 1.47506 39.3919 0.590673 37.173 0.543174C35.3862 0.502461 34.0336 1.41625 33.4432 3.10587C32.7353 5.12797 32.4412 7.36043 31.9142 9.43909C30.8587 13.625 29.6327 17.7643 28.2364 21.8567C25.4254 30.1205 21.8939 38.1213 17.6826 45.7669C12.9001 54.4481 7.19096 62.5855 0.655235 70.0367C0.407618 70.306 0.390041 70.7145 0.613615 71.004C0.837189 71.2935 1.23686 71.3798 1.55998 71.2084C0.675592 71.6268 0.996777 71.145 1.22296 71.3395C1.30045 71.3902 1.38618 71.4269 1.47629 71.4481C1.87438 71.6178 2.2589 71.8123 2.64794 72.0023C3.80601 72.5677 4.95278 73.1536 6.09954 73.7394C8.60343 75.0219 11.0915 76.327 13.5954 77.6072C21.7675 81.7803 30.9484 84.1417 39.971 85.5644C45.3643 86.4016 50.8021 86.922 56.2564 87.1228C61.7346 87.349 67.3079 87.4237 72.7816 87.0324C74.8444 86.8853 76.0455 85.8652 76.6969 83.9155C77.5496 81.3664 78.0992 78.6816 78.7801 76.0827C80.2186 70.5984 81.6511 65.1119 83.0776 59.6231C86.2035 47.651 88.5061 35.6089 89.3023 23.241C89.3497 22.5172 88.2256 22.5217 88.1713 23.241L88.1691 23.2387Z"
            fill="#232323"
        />
        <path
            d="M104.26 26.4641C108.71 44.674 108.291 63.7342 103.044 81.7305C101.551 86.8333 99.6055 91.7506 97.4658 96.6136C97.0768 97.4935 98.3434 98.2783 98.7845 97.3826C102.958 88.9142 105.665 79.6112 107.223 70.3172C108.805 60.9552 109.132 51.4245 108.198 41.976C107.649 36.6445 106.689 31.3633 105.328 26.1791C105.147 25.4893 104.091 25.7811 104.26 26.4732V26.4641Z"
            fill="#232323"
        />
        <path
            d="M92.6385 104.125L92.5707 104.578C92.5391 104.676 92.5344 104.782 92.5571 104.883C92.5611 104.984 92.5924 105.083 92.6476 105.168C92.8029 105.435 93.1034 105.583 93.4097 105.543C93.716 105.503 93.9684 105.283 94.0499 104.985L94.1902 104.564C94.2474 104.354 94.2189 104.131 94.111 103.942C94.0029 103.763 93.8307 103.631 93.6292 103.573C93.4201 103.517 93.1969 103.546 93.0095 103.655C92.8261 103.758 92.6923 103.931 92.6385 104.134V104.125Z"
            fill="#232323"
        />
        <path
            d="M93.0268 115.448C92.0059 115.385 91.1518 114.65 90.9368 113.65C90.7513 112.745 90.9888 111.841 90.6812 110.936C90.1994 109.547 88.8989 108.796 87.6571 108.174C86.7795 107.735 86.0059 109.061 86.8858 109.493C87.6729 109.879 88.6591 110.312 89.1477 111.076C89.7154 111.981 89.3512 113.166 89.6475 114.154C90.0999 115.656 91.5068 116.588 93.0403 116.642C93.8252 116.67 93.8049 115.512 93.0403 115.435L93.0268 115.448Z"
            fill="#232323"
        />
        <path
            d="M84.5539 106.408C85.4021 106.408 85.4043 105.089 84.5539 105.089C83.7034 105.089 83.7034 106.408 84.5539 106.408Z"
            fill="#232323"
        />
        <path
            d="M75.7077 108.158C61.3426 108.246 47.2082 104.971 34.2455 98.8235C33.4628 98.4526 32.773 99.6084 33.5669 99.9952C46.602 106.41 61.2069 109.529 75.7145 109.269C76.4247 109.257 76.4292 108.158 75.7145 108.163L75.7077 108.158Z"
            fill="#232323"
        />
      </svg>

      <svg
          class="path10"
          width="97"
          height="88"
          viewBox="0 0 97 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M90.5357 22.9378C88.3372 43.5954 86.0731 64.5267 78.6428 83.9267C78.3397 84.7184 78.0005 85.544 77.3423 86.0778C76.537 86.7314 75.4219 86.8151 74.386 86.8717C61.6969 87.5502 48.931 88.2288 36.3188 86.6817C23.7067 85.1346 11.1284 81.2532 0.972656 73.6239C1.48836 74.0107 11.0674 59.8085 11.8862 58.4807C15.2301 53.0625 18.1782 47.4097 20.7074 41.5665C23.675 34.7018 25.6971 27.4909 27.6039 20.2756C28.5945 16.5299 29.5536 12.7752 30.6144 9.04769C31.3359 6.50309 31.8946 1.7577 35.0409 0.966047C36.1582 0.683314 95.159 10.9748 96.2922 11.1852"
            fill="white"
        />
      </svg>

      <svg
          class="group3"
          width="98"
          height="91"
          viewBox="0 0 98 91"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M89.9505 24.9378C87.8719 43.5055 85.6711 62.34 79.7133 80.1273C79.0076 82.2399 78.4105 84.6714 77.2931 86.6076C76.7231 87.5983 75.8026 87.7883 74.7349 87.8697C73.5135 87.9624 72.2876 87.9964 71.0639 88.0597C66.1896 88.304 61.313 88.5121 56.4319 88.5867C46.957 88.7247 37.4142 88.2927 28.1224 86.3113C18.5661 84.2756 9.34896 80.634 1.4754 74.7622L0.473397 76.4744C1.79206 77.0535 2.83252 75.158 3.48394 74.3053C4.90213 72.4483 6.24342 70.5303 7.57339 68.6099C10.256 64.7399 12.8865 60.8653 15.2027 56.7645C19.8085 48.6269 23.4787 39.9943 26.1433 31.0313C27.5004 26.494 28.654 21.9047 29.8595 17.3289C30.4476 15.0987 31.1081 12.8844 31.669 10.6496C32.0128 9.29252 32.2843 7.89921 32.8 6.59185C33.0437 5.92807 33.3978 5.31019 33.8472 4.76426C34.0588 4.51818 34.3076 4.30676 34.5846 4.13773C34.8108 4.01106 35.5029 3.87761 35.055 3.88666C35.2267 3.88888 35.3981 3.90021 35.5685 3.92059C36.4212 4.00428 37.0183 4.10832 38.0317 4.25987C41.4245 4.76879 44.8173 5.32973 48.2101 5.88841C57.7099 7.45965 67.2097 9.07161 76.7096 10.7243C83.0134 11.81 89.3082 12.9658 95.6255 13.9768L95.863 14.0108C96.2317 14.0718 95.6368 13.9927 95.8857 14.0108C95.9354 14.0108 95.9874 14.0289 96.0372 14.0379C97.1681 14.2437 97.6476 12.5179 96.5122 12.3098C91.2239 11.3372 85.9221 10.428 80.6226 9.51192C71.0413 7.85322 61.457 6.22091 51.8698 4.61498C48.0947 3.98392 44.3174 3.35738 40.5355 2.76704C39.3549 2.58156 38.1742 2.40062 36.9912 2.2355C36.385 2.15181 35.711 1.98896 35.0935 2.00931C32.6055 2.12919 31.2687 5.10581 30.6467 7.1166C29.4886 10.8713 28.5952 14.7459 27.5954 18.5481C25.1775 27.7426 22.7234 36.9167 18.7515 45.5887C16.0491 51.5491 12.8588 57.276 9.21324 62.711C6.6596 66.486 4.15119 70.3697 1.2741 73.9072C1.09993 74.1221 0.921247 74.3347 0.735774 74.5383C0.226854 75.0992 0.665656 74.398 1.46409 74.7464C0.290186 74.2329 -0.571584 75.6918 0.462088 76.4586C15.698 87.8403 35.2247 90.6337 53.7629 90.5975C58.8657 90.5862 63.9639 90.3713 69.0599 90.1135C71.3829 89.9936 73.9207 90.1135 76.1984 89.6159C78.2341 89.1635 79.028 87.5802 79.7065 85.7707C83.1287 76.6509 85.4019 67.1442 87.0802 57.5585C88.9756 46.7445 90.0071 35.8446 91.1086 24.922C91.1855 24.1711 90.0229 24.1846 89.9392 24.922L89.9505 24.9378Z"
            fill="#232323"
        />
        <path
            d="M75.7863 5.84327C74.9154 2.28083 69.5458 2.96844 67.6436 5.15113C65.1171 8.03954 65.5174 12.8234 67.5463 15.8543C68.1185 16.7093 69.4417 15.9561 68.9351 15.0423C67.6209 12.6696 66.8858 9.55725 68.2113 7.01717C68.7039 5.99538 69.597 5.22265 70.679 4.88197C71.9795 4.51329 74.212 4.58341 74.6282 6.15993C74.825 6.9086 75.9695 6.59194 75.7863 5.841V5.84327Z"
            fill="#232323"
        />
        <path
            d="M62.116 4.3662C61.1751 3.31217 60.1618 2.31243 58.6689 2.23778C57.4506 2.1899 56.2583 2.59889 55.3259 3.38455C52.7293 5.53784 53.1364 9.02564 54.1429 11.8801C54.4777 12.8278 55.9524 12.4456 55.6652 11.4617C55.0251 9.34456 54.351 6.73437 55.9638 4.87286C56.567 4.16644 57.4262 3.7287 58.3523 3.65597C59.6212 3.57681 60.44 4.38429 61.2316 5.23928C61.7767 5.83641 62.6498 4.95202 62.116 4.35489V4.3662Z"
            fill="#232323"
        />
        <path
            d="M48.9127 1.11135C46.9969 -1.07361 44.2465 0.317435 42.7243 2.24228C40.9374 4.50415 40.6886 7.73409 42.3194 10.1339C42.8871 10.9663 44.2465 10.1882 43.6765 9.33775C42.5473 7.60798 42.4939 5.38829 43.5385 3.60619C44.4433 2.06359 46.4654 0.213389 48.0623 1.96633C48.587 2.54085 49.4194 1.69491 48.9105 1.11814L48.9127 1.11135Z"
            fill="#232323"
        />
      </svg>

      <svg
          class="group4"
          width="66"
          height="65"
          viewBox="0 0 66 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M64.6805 16.6661C51.5119 15.7275 38.2981 14.3477 25.324 11.9162C21.8996 11.2738 18.509 10.4958 15.1185 9.70411C14.2929 9.50959 13.9468 10.74 14.7679 10.9753C20.9812 12.7622 27.4705 13.7461 33.8626 14.6576C40.5758 15.6166 47.3207 16.3427 54.0791 16.9195C57.6152 17.221 61.152 17.4789 64.6895 17.693C65.3455 17.7337 65.3409 16.7227 64.6895 16.6752L64.6805 16.6661Z"
            fill="#F3D8D9"
        />
        <path
            d="M61.0908 33.3406C47.2527 31.3592 33.263 30.5359 19.5222 27.8217C16.1294 27.159 12.7864 26.3469 9.46823 25.4083C8.67431 25.1821 8.38479 26.3447 9.13347 26.6252C15.2654 28.9323 22.0035 29.8347 28.4566 30.7666C35.7624 31.8207 43.1044 32.6055 50.4442 33.3927C53.9388 33.7681 57.4356 34.1391 60.9257 34.5485C61.6042 34.6276 61.7829 33.4311 61.0908 33.3316V33.3406Z"
            fill="#F3D8D9"
        />
        <path
            d="M56.7713 50.377C49.7595 50.3905 42.7477 49.7549 35.7902 48.9836C27.695 48.0789 19.6043 46.9186 11.638 45.2063C8.15476 44.4577 4.66018 43.6117 1.30358 42.4016C0.477995 42.1031 0.129667 43.4081 0.941677 43.7112C7.56216 46.1676 14.7006 47.3506 21.6513 48.4272C29.6809 49.6713 37.7716 50.5805 45.8759 51.1415C49.4949 51.3925 53.1365 51.5803 56.7713 51.5576C57.5313 51.5576 57.5313 50.3747 56.7713 50.377Z"
            fill="#F3D8D9"
        />
        <path
            d="M57.1401 7.23865C54.0707 14.3771 52.2838 22.0878 50.3137 29.5814C48.3301 37.1315 46.3125 44.711 43.302 51.9308C41.5745 56.0064 39.528 59.9392 37.1814 63.6925C36.6679 64.5272 37.9232 65.217 38.4729 64.448C42.9966 58.1487 45.8375 50.7094 48.1356 43.3561C50.4811 35.8512 52.225 28.1767 54.324 20.6018C55.5228 16.2658 56.9297 12.0067 58.3569 7.7521C58.5831 7.04866 57.4386 6.53974 57.1378 7.23865H57.1401Z"
            fill="#F3D8D9"
        />
        <path
            d="M40.861 4.73475C37.1493 20.4592 32.0171 35.8128 24.9352 50.3475C22.9266 54.4686 20.7507 58.5038 18.5793 62.539C18.127 63.3623 19.3461 64.0725 19.8324 63.2718C24.0463 56.3618 27.5589 48.9972 30.7052 41.5466C33.874 34.0828 36.568 26.4262 38.771 18.6226C40.0256 14.1381 41.0879 9.60907 41.958 5.03558C42.0937 4.32988 41.0374 4.02 40.8678 4.73475H40.861Z"
            fill="#F3D8D9"
        />
        <path
            d="M26.2457 1.3827C22.534 17.1049 17.4018 32.4607 10.3199 46.9955C8.31141 51.1166 6.13549 55.1518 3.9641 59.1869C3.51173 60.0102 4.73088 60.7205 5.21718 59.9198C9.43103 53.0098 12.946 45.6451 16.09 38.1923C19.2568 30.7292 21.9485 23.0734 24.149 15.2706C25.4036 10.786 26.4666 6.25702 27.3382 1.68353C27.4717 0.977829 26.4154 0.667954 26.2457 1.3827Z"
            fill="#F3D8D9"
        />
      </svg>
    </div>
    <div class="text-group">
      <div class="archived-title mt-4">সম্মিলিত রুটিন এবং আর্কাইভ</div>
      <div class="archived-content mt-3">লাইভ পরীক্ষা মিস হলে দেখে নিন আর্কাইভ থেকে। </div>
      <div class="archived-button">
        সবগুলো দেখুন
        <svg
            class="archived-button-arrow"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="top: 4px;"
        >
          <path
              d="M13.2673 4.20926C12.9674 3.92357 12.4926 3.93511 12.2069 4.23504C11.9213 4.53497 11.9328 5.0097 12.2327 5.29539L18.4841 11.25H3.75C3.33579 11.25 3 11.5858 3 12C3 12.4142 3.33579 12.75 3.75 12.75H18.4842L12.2327 18.7047C11.9328 18.9904 11.9213 19.4651 12.2069 19.7651C12.4926 20.065 12.9674 20.0765 13.2673 19.7908L20.6862 12.7241C20.8551 12.5632 20.9551 12.358 20.9861 12.1446C20.9952 12.0978 21 12.0495 21 12C21 11.9504 20.9952 11.902 20.986 11.8551C20.955 11.6419 20.855 11.4368 20.6862 11.276L13.2673 4.20926Z"
              fill="#FA3434"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import 'vue3-carousel/dist/carousel.css';
import { defineComponent } from "vue";
import {StaticTags, URLs} from "@/static";
import { useRouter } from "vue-router";
import store from "@/store";

export default defineComponent({

  setup() {
    const router = useRouter();
    const handleAllButtonClick = () => {
      store.dispatch(StaticTags.DISPATCH_ID_FLOW_TYPE, StaticTags.TYPE_LIVE_COURSE)
      router.push({
        name: URLs.ROUTE_LIVE_COURSE_EXAM_LIST_NAME,
      })
    };

    return {
      handleAllButtonClick,
    };
  },
});
</script>
<style >
.archived-section {
  box-sizing: border-box;
  border-radius: 16px;
  border-style: solid;
  border-color: #e6e4e4;
  border-width: 1px;
  opacity: 0.9599999785423279;
  position: relative;
  width: 100%;
  background: #ffffff;
  height: 148px;
}

.archived-title {
  color: #000000;
  text-align: center;
  font: 600 20px/20px "Noto Sans Bengali", sans-serif;
  position: relative;
  height: 15.95px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}

.archived-button {
  color: #FA3434;
  text-align: center;
  font: 500 20px/30px "Noto Sans Bengali", sans-serif;
  position: relative;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.group,
.group * {
  box-sizing: border-box;
}
.group {
  position: absolute;
  inset: 0;
}
.path {
  position: absolute;
  left: 131.17px;
  top: 26.26px;
  overflow: visible !important;
}
.path2 {
  position: absolute;
  left: 130.25px;
  top: 24.26px;
  overflow: visible !important;
}
.path3 {
  position: absolute;
  left: 114.19px;
  top: 10.35px;
  overflow: visible !important;
}

.group2 {
  position: absolute;
  left: 113.46px;
  top: 11.54px;
  overflow: visible !important;
}

.path10 {
  position: absolute;
  left: 111.97px;
  top: 10.96px;
  overflow: visible !important;
}

.group3 {
  position: absolute;
  left: 112px;
  top: 10px;
  overflow: visible !important;
}
.group4 {
  position: absolute;
  left: 130.48px;
  top: 28.98px;
  overflow: visible !important;
}

</style>